import React, { useEffect, useRef, useState, useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import UploadIcon from "../customIcons/UploadIcon";
import APIURLConstants from "../../common/ApiURLConstants";
import { coachProfileService } from "../../services";
import CircularProgress from "@material-ui/core/CircularProgress";
import ImageCropper from '../dialog/ImageCropperDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    minHeight: "80px",
    textAlign: "center",
    borderRadius: "4px",
  },
  grid: {
    padding: theme.spacing(1),
    alignSelf: "center",
  },
  upload: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    display: "flex",
    overflow: "hidden",
    position: "relative",
    borderRadius: "4px",
    // width: '150px',
    width: "40%",
    cursor: "pointer",
    //color: 'red !important'
  },
  uploadInner: {
    "&:hover": {
      //border: `1px dashed ${theme.palette.text.primary}`,
      cursor: "pointer",
    },
    display: "flex",
    flexDirection: "column",
    //border: `1px dashed ${theme.palette.text.disabled}`,
    width: "100%",
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    backgroundColor: "#e5e5e5",
    //color: theme.palette.text.secondary,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: theme.spacing(1),
  },
  input: {
    fontSize: "80px",
    position: "absolute",
    left: "-450px",
    top: 0,
    opacity: 0,
    cursor: "pointer",
  },
  image: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  imageMargin: {
    marginRight: theme.spacing(4),
  },
}));

const ImageFileUpload = (props) => {

  const classes = useStyles();
  const [image, setImage] = useState(null);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);

  const maxFileSize = props.maxFileSize;
  const allowedFileType = props.allowedFileType;
  //const { userName, profilePhoto } = useContext(UserProfileContext);
  let videoImg =
    "data:image/png;base64,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";
  useEffect(() => {
    if (props.userName) {
      if (props.data) {
        if (!image || image == null) {
          if (allowedFileType === "image/*") {
            let profileurl = APIURLConstants.GET_PROFILE_PHOTO + props.userName;
            coachProfileService
              .getCoachProfilePhoto(props.userName)
              .then((Photo) => {
                props.data && setImage(Photo);
              })
              .catch((err) => {
                //console.log(err);
              });
          } else {
            setImage(videoImg);
          }
        }
      } else setImage(null);
    }
  }, [props.data]);


  const onClose = () => {
    setImage(null);
    setShowCropper(false);
  }

  const handleOnChange = (e) => {
    let files = e.target.files;

    if (files && files[0]) {
      if (validateFile(files) === true) {
        setIsLoading(true);
        if (allowedFileType === "video/*")
          props.onChange(files[0]);
        else {
          setShowCropper(true);
          setOriginalImage(files[0]);
        }
        let reader = new FileReader();
        reader.onload = (rEvent) => {
          setImage(rEvent.target.result);
          setIsLoading(false);
        };
        reader.readAsDataURL(files[0]);
      }
    }
  };

  const saveCroppedImage = (croppedImage) => {
    if (croppedImage != null) {
      var blobBin = atob(croppedImage.split(',')[1]);
      var array = [];
      for (var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }

      var pImage = new Blob([new Uint8Array(array)], { type: originalImage.type });
      setIsLoading(true);
      props.onChange(pImage);
      let reader = new FileReader();
      reader.onload = (rEvent) => {
        setImage(rEvent.target.result);
        setIsLoading(false);
        setShowCropper(false);
      };
      reader.readAsDataURL(pImage);
    }
  };

  const handleRemoveFile = (e) => {
    setImage(null);
    props.onDelete();
  };

  const validateFile = (files) => {
    setShowError(null);
    const fsize = files[0].size;
    const filesizeInMB = Math.round(fsize / 1024 / 1024);
    // The size of the file.
    if (filesizeInMB > maxFileSize) {
      setShowError("Please select a file less than " + maxFileSize + "  MB");
      return false;
    }
    if (files[0].type.match(allowedFileType) == null) {
      setShowError("Please upload valid file");
      return false;
    }
    return true;
  };

  const RemoveImageBadge = withStyles((theme) => ({
    badge: {
      color: "#fff",
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.8,
      cursor: "pointer",
    },
  }))(Badge);

  function showImage() {
    let img = null;
    let imgVal = allowedFileType === "image/*" ? image : videoImg;
    if (imgVal && imgVal !== null)
      img = (
        <div className={classes.imageMargin}>
          <Tooltip title="Remove">
            <RemoveImageBadge
              onClick={handleRemoveFile}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              badgeContent={<CloseIcon fontSize="small" />}
            >
              <Avatar alt="photo" src={imgVal} className={classes.image} />
            </RemoveImageBadge>
          </Tooltip>
        </div>
      );
    return img;
  }

  return (
    <Grid container>
      <Grid item md={12} xs={12} className={classes.grid}>
        <div className={classes.root}>
          {image && image !== null ? (
            showImage()
          ) : (
            <div className={classes.upload}>
              {isLoading && <CircularProgress color="secondary" />}
              <div className={classes.uploadInner} >
                <UploadIcon style={props.showRed ? { color: 'red' } : {}} />
                {/* <Hidden xsDown> */}
                <Typography variant="body2" style={props.showRed ? { color: 'red' } : {}}>
                  Drop here or click here to select.
                </Typography>
                {/* </Hidden> */}
                <input
                  type="file"
                  className={classes.input}
                  onChange={handleOnChange}
                  title=" "
                  accept={allowedFileType}
                />
              </div>
            </div>
          )}
          {image && image !== null && (allowedFileType === "image/*") &&
            <>
              <ImageCropper data={image} open={showCropper}
                saveCroppedImage={saveCroppedImage} onClose={onClose} /> </>
          }
        </div>
        {showError && (
          <Typography variant="error" color="error">
            {showError}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default ImageFileUpload;
